// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
export const getRecentLoader = state => state.vouchersReducer.recentLoading;
export const getSearchLoader = state => state.vouchersReducer.searchLoading;
export const getBookshopTotal = state => state.vouchersReducer.bookshopTotal;
export const getRecentVouchers = state => state.vouchersReducer.recentVouchers;
export const getText = state => state.vouchersReducer.text;
export const getVouchers = state => state.vouchersReducer.vouchers;
